module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/target01-e3365e3beda94c768d763bf90a89f694.png";